<div class="modal-filter-picker d-flex flex-column">
    <i class="btn-close icon-edponline-Bop-071" (click)="dismissModal(false)" aria-hidden="true"></i>

    <ng-container *ngIf="!!title">
        <h1 class="modal-filter-picker-title">{{ title | translate }}</h1>
    </ng-container>

    <div class="modal-filter-picker-list">
        <ng-container *ngFor="let filter of filterList">
            <button class="button button-outline" [ngClass]="{'button-selected': filter.value === selectedFilter.value}"
                (click)="selectFilter(filter)">
                {{ filter.label }}
            </button>
        </ng-container>
    </div>

</div>